import { DEFAULT_CONTROLLO_PREFS } from "./controlloCards";

/**
 * Registry delle card della dashboard Panoramica.
 * Contiene i metadati di ogni card e il layout di default.
 * - defaultSize: "detailed" (card alta min-h-[210px] con KPI, come la prima fila) | "compact" (barra 88px)
 * - requiresFlag: se presente, la card è visibile solo se il flag è truthy
 * - fallbackFor: la card è mostrata al posto di quella con questo id quando il flag manca
 */
export const DASHBOARD_CARDS_REGISTRY = [
  {
    id: "calendario",
    label: "Calendario & Attività",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "fascicoli",
    label: "Fascicoli Assistenziali",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "alloggiati",
    label: "Alloggiati Web",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "posti-liberi",
    label: "Camere e Posti Letto",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "ospiti-rete",
    label: "Ospiti in Rete",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "personale",
    label: "Personale",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "diario-consegne",
    label: "Diario Consegne",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "immobiliare",
    label: "Immobiliare",
    defaultSize: "detailed",
    defaultVisible: true,
  },
  {
    id: "fatturazione",
    label: "Fatturazione",
    defaultSize: "compact",
    defaultVisible: true,
    requiresFlag: "dashboardFatturazione",
  },
  {
    id: "newsletter",
    label: "Newsletter",
    defaultSize: "compact",
    defaultVisible: true,
    fallbackFor: "fatturazione",
  },
  {
    id: "deblistering",
    label: "Deblistering",
    defaultSize: "compact",
    defaultVisible: true,
  },
  {
    id: "risparmio",
    label: "Risparmio Insieme",
    defaultSize: "compact",
    defaultVisible: true,
  },
  {
    id: "documenti",
    label: "Documenti",
    defaultSize: "compact",
    defaultVisible: true,
  },
  {
    id: "prima-nota",
    label: "Prima Nota Ospiti",
    defaultSize: "compact",
    defaultVisible: true,
  },
  {
    id: "arredo",
    label: "Arredo",
    defaultSize: "compact",
    defaultVisible: true,
  },
];

/** Layout di default: panoramica + Controllo completo (struttura corrente) */
export const DEFAULT_DASHBOARD_PREFS = {
  panoramica: DASHBOARD_CARDS_REGISTRY.map((c) => ({
    id: c.id,
    visible: c.defaultVisible,
    size: c.defaultSize,
  })),
  controllo: DEFAULT_CONTROLLO_PREFS,
  version: 1,
};

export const CARDS_BY_ID = Object.fromEntries(
  DASHBOARD_CARDS_REGISTRY.map((c) => [c.id, c])
);
